import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  VariantDisplayType,
  GetProductViewQuery,
} from '@notino/shared/definitions/types';

import { variantInfo } from '../../../helpers/utils';
import messages from '../messages';
import { getDisplayType } from '../utils';

interface IVariantNameProps {
  variant: GetProductViewQuery['productDetailByMasterId'][number]['variants'][number];
  unit: GetProductViewQuery['productDetailByMasterId'][number]['unit'];
  variantDisplayType: GetProductViewQuery['productDetailByMasterId'][number]['variantDisplayType'];
}

export const VariantName: React.FC<IVariantNameProps> = ({
  variant,
  unit,
  variantDisplayType,
}) => {
  const displayType = getDisplayType(variantDisplayType);
  const { parameters, attributes, additionalInfo } = variant;
  const variantInformation = variantInfo(variant);

  let NameContent = null;
  if (parameters.package) {
    NameContent = (
      <span>
        {parameters.package} {unit}{' '}
      </span>
    );
  }

  if (attributes.Sample && NameContent) {
    NameContent = (
      <span>
        {NameContent} <FormattedMessage {...messages.perfumeSample} />
      </span>
    );
  }

  if (displayType !== VariantDisplayType.Tiles && variantInformation) {
    NameContent = <span>{variantInformation}</span>;
  }
  if (displayType === VariantDisplayType.Thumbnail && additionalInfo) {
    NameContent = <span>{additionalInfo}</span>;
  }

  return NameContent;
};
